"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var proxiedFind = function (arr, proxy, args) {
    for (var i = 0, len = arr.length; i < len; i++) {
        var cb = args[0];
        var proxiedValue = proxy[i];
        var realValue = proxiedValue._isProxy
            ? proxiedValue.valueOf()
            : proxiedValue;
        if (cb(proxiedValue, i) ||
            (realValue !== proxiedValue && cb(realValue, i)))
            return proxy[i];
    }
    return void 0;
};
exports.default = proxiedFind;
//# sourceMappingURL=proxiedFind.js.map